var _a;
import React from 'react';
import PropTypes from 'prop-types';
import { round } from 'lodash-es';
import * as measurementUnits from '../../constants/measurementUnits';
import * as platforms from '../../constants/platform';
export default function Measurement(_a) {
    var value = _a.value, platform = _a.platform, _b = _a.includeUnitIfZero, includeUnitIfZero = _b === void 0 ? false : _b, isText = _a.isText, unit = _a.unit;
    var displayUnit = unit ||
        getDefaultUnit({
            platform: platform,
            isText: isText,
        });
    if (value === 0 && !includeUnitIfZero) {
        displayUnit = '';
    }
    return (React.createElement("span", null,
        round(value, 2),
        displayUnit));
}
var unitMap = (_a = {},
    _a[platforms.IOS] = measurementUnits.POINT,
    _a[platforms.WATCHOS] = measurementUnits.POINT,
    _a[platforms.ANDROID] = measurementUnits.DENSITY_INDEPENDENT_PIXEL,
    _a[platforms.WEB] = measurementUnits.PIXEL,
    _a);
function getDefaultUnit(_a) {
    var platform = _a.platform, isText = _a.isText;
    if (platform === platforms.ANDROID && isText) {
        return measurementUnits.SCALE_INDEPENDENT_PIXEL;
    }
    return unitMap[platform];
}
Measurement.propTypes = {
    value: PropTypes.number,
    platform: PropTypes.string.isRequired,
    includeUnitIfZero: PropTypes.bool,
    isText: PropTypes.bool,
    unit: PropTypes.string,
};
